import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cp0043',
    ecrans: ['00-2']
});
